import { render, staticRenderFns } from "./RecipeDetail.vue?vue&type=template&id=1f5c0ee8&scoped=true&"
import script from "./RecipeDetail.vue?vue&type=script&lang=ts&"
export * from "./RecipeDetail.vue?vue&type=script&lang=ts&"
import style0 from "./RecipeDetail.vue?vue&type=style&index=0&id=1f5c0ee8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5c0ee8",
  null
  
)

/* custom blocks */
import block0 from "./RecipeDetail.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports